var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStackedEqualBarEsg = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 10,
  width: 5,
  height: 10,
  transform: "rotate(90 10 0)",
  fill: "#FF8900"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 23,
  width: 5,
  height: 12,
  transform: "rotate(90 23 0)",
  fill: "#FFBF0D"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  width: 5,
  height: 8,
  transform: "rotate(90 32 0)",
  fill: "#9FD926"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 15,
  y: 9,
  width: 5,
  height: 15,
  transform: "rotate(90 15 9)",
  fill: "#9FD926"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 9,
  width: 5,
  height: 5,
  transform: "rotate(90 21 9)",
  fill: "#04BD24"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 9,
  width: 5,
  height: 10,
  transform: "rotate(90 32 9)",
  fill: "#048119"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 24,
  y: 17.8828,
  width: 5.17647,
  height: 24,
  transform: "rotate(90 24 17.8828)",
  fill: "#04BD24"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 18,
  width: 5,
  height: 7,
  transform: "rotate(90 32 18)",
  fill: "#048119"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 6,
  y: 27,
  width: 5,
  height: 6,
  transform: "rotate(90 6 27)",
  fill: "#8C0200"
})), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 27,
  width: 5,
  height: 13,
  transform: "rotate(90 20 27)",
  fill: "#BC0300"
})), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 27,
  width: 5,
  height: 11,
  transform: "rotate(90 32 27)",
  fill: "#FD4F03"
})));
export { SvgStackedEqualBarEsg as ReactComponent };
export default __webpack_public_path__ + "stacked_equal_bar_esg.012dea54ca25c1d56df14c9e50f6e6bf.svg";